// Luxury Product Page Enhancements

document.addEventListener('DOMContentLoaded', function() {
  // Add smooth scrolling to product sections
  const productSections = document.querySelectorAll('.product-info, .product__info-container');
  
  // Add entrance animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);
  
  productSections.forEach(section => {
    observer.observe(section);
  });
  
  // Enhanced button interactions
  const buttons = document.querySelectorAll('.product-form__cart-submit, .button, .btn');
  buttons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
      this.style.boxShadow = '0 6px 20px rgba(var(--color-button), 0.4)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 4px 16px rgba(var(--color-button), 0.3)';
    });
    
    button.addEventListener('mousedown', function() {
      this.style.transform = 'translateY(0)';
    });
    
    button.addEventListener('mouseup', function() {
      this.style.transform = 'translateY(-2px)';
    });
  });
  
  // Enhanced form interactions
  const formInputs = document.querySelectorAll('input, select, textarea');
  formInputs.forEach(input => {
    input.addEventListener('focus', function() {
      this.parentElement.classList.add('focused');
    });
    
    input.addEventListener('blur', function() {
      this.parentElement.classList.remove('focused');
    });
  });
  
  // Smooth price transitions
  const priceElements = document.querySelectorAll('.price');
  priceElements.forEach(price => {
    price.style.transition = 'all 0.3s ease';
  });
  
  // Enhanced checkbox interactions
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      const label = this.parentElement.querySelector('label');
      if (this.checked) {
        this.parentElement.classList.add('checked');
        if (label) {
          label.style.color = 'rgb(var(--color-button))';
        }
      } else {
        this.parentElement.classList.remove('checked');
        if (label) {
          label.style.color = 'rgb(var(--color-foreground))';
        }
      }
    });
  });
  
  // Add loading state to add to cart button
  const addToCartButton = document.querySelector('.product-form__cart-submit');
  if (addToCartButton) {
    const originalText = addToCartButton.textContent;
    
    addToCartButton.addEventListener('click', function() {
      this.textContent = 'DODAJANJE...';
      this.disabled = true;
      this.style.opacity = '0.7';
      
      // Re-enable after a short delay (you can adjust this based on your cart logic)
      setTimeout(() => {
        this.textContent = originalText;
        this.disabled = false;
        this.style.opacity = '1';
      }, 2000);
    });
  }
  
  // Enhanced variant selection
  const variantSelects = document.querySelectorAll('.product-form__input select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      // Add a subtle animation when variant changes
      const priceElement = document.querySelector('.price');
      if (priceElement) {
        priceElement.style.transform = 'scale(1.02)';
        setTimeout(() => {
          priceElement.style.transform = 'scale(1)';
        }, 200);
      }
    });
  });
  
  // Smooth quantity input interactions
  const quantityInputs = document.querySelectorAll('.quantity-input input');
  quantityInputs.forEach(input => {
    input.addEventListener('input', function() {
      const value = parseInt(this.value);
      if (value > 0) {
        this.parentElement.classList.add('has-value');
      } else {
        this.parentElement.classList.remove('has-value');
      }
    });
  });
  
  // Add ripple effect to buttons
  function addRippleEffect(button) {
    button.addEventListener('click', function(e) {
      const ripple = document.createElement('div');
      ripple.classList.add('ripple');
      
      const rect = this.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;
      
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      
      this.appendChild(ripple);
      
      setTimeout(() => {
        ripple.remove();
      }, 600);
    });
  }
  
  // Apply ripple effect to main buttons
  const mainButtons = document.querySelectorAll('.product-form__cart-submit, .button');
  mainButtons.forEach(addRippleEffect);
  
  // Enhanced media gallery interactions
  const mediaItems = document.querySelectorAll('.product__media-item');
  mediaItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.02)';
    });
    
    item.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1)';
    });
  });
  
  // Add luxury loading animation
  const style = document.createElement('style');
  style.textContent = `
    .animate-in {
      animation: fadeInUp 0.6s ease-out forwards;
    }
    
    .focused {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(var(--color-button), 0.2);
    }
    
    .checked {
      background-color: rgba(var(--color-button), 0.1);
      border-radius: 6px;
      padding: 0.5rem;
    }
    
    .has-value {
      box-shadow: 0 0 0 2px rgba(var(--color-button), 0.2);
    }
    
    .ripple {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.3);
      animation: rippleAnimation 0.6s ease-out;
      pointer-events: none;
    }
    
    @keyframes rippleAnimation {
      0% {
        transform: scale(0);
        opacity: 0.6;
      }
      100% {
        transform: scale(1);
        opacity: 0;
      }
    }
    
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);
});

// Add smooth scrolling polyfill for older browsers
if (!window.CSS || !CSS.supports('scroll-behavior', 'smooth')) {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
} 